import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from '../../widgets/Selectors/WidgetBranchSelector'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import { lzDownloadBlobFile, wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import WidgetEmployeeSelector from 'src/widgets/Selectors/WidgetEmployeeSelector'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import DataReportTable from './DataReportTable'
import Loading from 'src/helpers/commons/loader'
import ErrorMessage from 'src/widgets/ErrorComponent/ErrorMessage'
import { wtConvertHourValue } from 'src/helpers/commons/moment'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { EmployeeAttendanceTypeOptions, JobTypeOptions } from 'src/helpers/commons/dropdownOptions'
import Select from 'react-select'
import { DatePicker } from 'antd'
const { RangePicker } = DatePicker
import {
  getExcelDateExportConfig,
  useMasterDateTimeFormats,
} from 'src/helpers/commons/masterDateFormat'

export default function EmployeeAttendanceReport() {
  const Base = new BaseListing()
  const { dateFormat, formatDate, formatDateTime } = useMasterDateTimeFormats()
  const [range, setRange] = useState(null)
  const [dateRange, setDateRange] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [Date, setDate] = useState('')
  const [Employees, setEmployees] = useState([])
  const [EmployeeId, setEmployeeId] = useState(0)
  const [EmployeeName, setEmployeeName] = useState('')
  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [EmployeeShifts, setEmployeeShifts] = useState([])
  const [EmployeeShiftId, setEmployeeShiftId] = useState(0)
  const [EmployeeShiftName, setEmployeeShiftName] = useState('')
  const [CheckOut, setCheckOut] = useState('')
  const [CheckIn, setCheckIn] = useState('')
  const [WorkingHours, setWorkingHours] = useState('')
  const [Remarks, setRemarks] = useState('')
  const [errors, setErrors] = useState([])
  const [isMore, setIsMore] = useState(false)
  const [reportData, setReportData] = useState([])
  const [JobType, setJobType] = useState('')
  const [ResignationStatus, setResignationStatus] = useState(0)
  const [AttendanceStatuses, setAttendanceStatuses] = useState([])


  const RESIGNATION_STATUS_ACTIVE = 0;
  const RESIGNATION_STATUS_RESIGNED = 1;
  const RESIGNATION_STATUS_TERMINATE = 2;
  const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
  const RESIGNATION_STATUS_RETIREMENT = 4;
  const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;

  const RESIGNATION_STATUS_NAME = {
    0: 'Active',
    1: 'Resigned',
    2: 'Terminated',
    3: 'Contract Discontinued',
    4: 'Retired',
    5: 'Passed Away',
  };

  const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
    { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
    { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
    { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
    { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
    { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
    { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  ];

  const generatePDF = () => {
    const doc = new jsPDF('landscape')
    const logo = 'assets/wil-icon.png'
    const img = new Image()
    var totalPagesExp = '{total_pages_count_string}'
    let yPosition = 45

    const headRows = [
      {
        content: 'Sr',
      },
      {
        dataKey: 'full_name',
        content: 'Employee Name',
      },
      {
        dataKey: 'designation.name',
        content: 'Designation',
      },
      {
        dataKey: 'department.name',
        content: 'Department',
      },
      {
        dataKey: 'Date',
        content: 'attendance_date',
      },
      {
        dataKey: 'check_in',
        content: 'Check In',
      },
      {
        dataKey: 'check_out',
        content: 'Check Out',
      },
      {
        dataKey: 'late_coming',
        content: 'Late Coming',
      },
      {
        dataKey: 'early_going',
        content: 'Early Going',
      },
      {
        dataKey: 'woking_hours',
        content: 'Working Hours',
      },
      {
        dataKey: 'shift_duration',
        content: 'Shift Duration',
      },
      {
        dataKey: 'difference',
        content: 'Difference',
      },
      {
        dataKey: 'oveetime_hours',
        content: 'Overtime Hours',
      },
      {
        dataKey: 'is_overtime_approved',
        content: 'Approved Ovetime',
      },
    ]
    const getDifference = (record) => {
      const { working_hours, updated_working_hours, shift_duration } = record
      if (updated_working_hours !== null) {
        return wtRoundNumberToSpecifedDigits(Math.abs(updated_working_hours - shift_duration) * 60, 2,) + ' min'
      }
      else if (working_hours !== null) {
        return wtRoundNumberToSpecifedDigits(Math.abs(working_hours - shift_duration) * 60, 2,) + ' min'
      }
      else {
        return '-'
      }
    }

    const getDifferenceColor = (record) => {
      const { working_hours, updated_working_hours, shift_duration } = record

      if (updated_working_hours !== null) {
        if (updated_working_hours > shift_duration) {
          return 'green'
        }
        else if (updated_working_hours < shift_duration) {
          return 'red'
        }
        else {
          return 'blue'
        }
      }
      else if (working_hours !== null) {
        if (working_hours > shift_duration) {
          return 'green'
        }
        else if (working_hours < shift_duration) {
          return 'red'
        }
        else {
          return 'blue'
        }
      }
      else {
        return 'blue'
      }
    }

    const employeeDetails = reportData.map((employee, index) => [
      index + 1,
      employee.employee.full_name,
      employee.employee.designation?.name || '',
      employee.employee.department?.name || '',
      { content: formatDate(employee.attendance_date, '-') },
      { content: employee.check_in || '-' },
      { content: employee.check_out || '-' },
      { content: employee.late_coming !== null ? employee.early_going + ' min' : '-' },
      { content: employee.early_going !== null ? employee.early_going + ' min' : '-' },

      // employee.working_hours,
      { content: wtConvertHourValue(employee.working_hours) },

      { content: wtConvertHourValue(employee.shift_duration) },

      {
        content: `${getDifference(employee)}`,
        styles: { textColor: getDifferenceColor(employee) }
      },
      {
        content: employee.overtime_hours
          ? wtRoundNumberToSpecifedDigits(employee.overtime_hours) + ' Hours'
          : '-',
        styles: { textColor: employee.overtime_hours ? 'green' : 'red' },
      },

      {
        content:
          employee.is_overtime_approved === 0
            ? '-'
            : employee.updated_overtime_hours
              ? wtRoundNumberToSpecifedDigits(employee.updated_overtime_hours) + ' Hours'
              : '-',
        styles: { textColor: employee.is_overtime_approved === 0 ? 'red' : 'green' },
      },
    ])

    doc.autoTable({
      head: [headRows],
      body: employeeDetails,
      startY: 45,
      margin: { top: 50, bottom: 20, left: 10, right: 10 },
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 280,
      styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        setFontSize: 8,
        font: 'helvetica',
      },

      didDrawPage: function (data) {
        //get page no
        totalPagesExp = doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
        let pageNo = doc.internal.getNumberOfPages()
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth() // Header

        doc.setTextColor('#3c4b64')
        doc.setFont('Helvetica', 'bold') //Header middle branch logo

        doc.addImage(logo, 'PNG', pageWidth - 280, 4, 25, 25)
        doc.line(pageWidth - 254, 7, pageWidth - 254, 27) // Adjust the coordinates as needed
        doc.setFontSize(11)
        doc.text('WAH', pageWidth - 251, 10, { align: 'left' })
        doc.setFont('Helvetica')
        doc.text('INDUSTRIES', pageWidth - 251, 15)
        doc.text('LIMITED', pageWidth - 251, 20)
        doc.setFontSize(9)
        doc.text('www.wahindustries.com', pageWidth - 251, 25)

        doc.setFontSize(14)
        doc.text('Employee Attendance Report', pageWidth - 20, 10, { align: 'right' }) // Add header separator

        yPosition -= -5 // Set alignment for the text that follows the line
        doc.setFont('Helvetica')
        doc.setFontSize(12)
        doc.setTextColor('#3c4b64')

        //Page No
        var str = 'Page ' + pageNo
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }

        doc.setTextColor('black')
        doc.text(str, 10, pageHeight - 4)
      },
    })

    doc.setFontSize(10)
    const printReport =
      'This Report is printed through ERP at ' + formatDateTime(moment(), moment().format('YYYY-MM-DD HH:mm:ss'))
    const styleReport = { halign: 'center' }
    const pageWidth = doc.internal.pageSize.width
    const textWidth =
      (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const startXForPrintReport = (pageWidth - textWidth) / 2
    const startYForPrintReport = doc.autoTable.previous.finalY + 20

    doc.text(printReport, startXForPrintReport, startYForPrintReport, styleReport)

    doc.save('EmployeeAttendance.pdf')
  }

  const changeValues = (key, val) => {
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
      Base.dropdownData('departments', { branch_id: val.value }, [setDepartments], 1)
    }
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'date_range') {
      setDateRange(val);
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    if (key === 'employee_id') {
      setEmployeeId(val.value)
      setEmployeeName(val.label)
    }
    if (key === 'resignation_status') {
      setResignationStatus(val.value)
      // setEmployeeName(val.label)
    }
    if (key === 'attendance_status') {
      setAttendanceStatuses(val || [])
    }
  }


  const getReportData = () => {
    if (dateRange.length < 2) {
      lzNotifyErrorMessageFromResult("Please select date range");
      return;
    }
    const fromDate = dateRange[0];
    const toDate = dateRange[1];
    setIsLoading(true)
    setIsLoading(true)
    wtApiCall(
      'reports/employee_attendance_report',
      {
        employee_id: EmployeeId,
        parent_branch_id: branchId,
        department_id: department_id,
        designation_id: designation_id,
        employee_shift_id: EmployeeShiftId,
        check_in: CheckIn,
        check_out: CheckOut,
        working_hours: WorkingHours,
        remarks: Remarks,
        from_date: fromDate.format('YYYY-MM-DD'),
        to_date: toDate.format('YYYY-MM-DD'),
        resignation_status: ResignationStatus,
        job_status: JobType,
        attendance_status: AttendanceStatuses.map(({ value }) => value),

      },
      'get',
      (response) => {
        const { data } = response
        setReportData(data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }

  const escapeExcelValue = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const getDifference = (record) => {
    let { working_hours, updated_working_hours, shift_duration, is_holiday } = record

    if (is_holiday) {
      shift_duration = 0
    }

    if (updated_working_hours !== null) {
      return (
        wtRoundNumberToSpecifedDigits(Math.abs(updated_working_hours - shift_duration) * 60, 2) +
        ' min'
      )
    }
    if (working_hours !== null) {
      return wtRoundNumberToSpecifedDigits(Math.abs(working_hours - shift_duration) * 60, 2) + ' min'
    }
    return '-'
  }

  const buildExcelAttendanceDateCell = (value) => {
    const exportConfig = getExcelDateExportConfig(value, dateFormat)

    if (exportConfig.type === 'empty') {
      return '<td></td>'
    }

    if (exportConfig.type === 'str') {
      return `<td x:str>${escapeExcelValue(exportConfig.value)}</td>`
    }

    return `<td style="mso-number-format:'${exportConfig.numberFormat}';" x:num>${exportConfig.value}</td>`
  }

  const buildExcelHtml = () => {
    const rows = reportData
      .map((item, index) => {
        const isSpecialType =
          item.type === 'Public Holiday' ||
          item.type === 'Weekly Holiday' ||
          item.type === 'On Move' ||
          item.type === 'Leave'

        const attendanceDateCell = buildExcelAttendanceDateCell(item.attendance_date)

        if (isSpecialType) {
          return `
            <tr>
              <td>${escapeExcelValue(index + 1)}</td>
              <td>${escapeExcelValue(item.employee?.id)}</td>
              <td>${escapeExcelValue(item.employee?.full_name)}</td>
              <td>${escapeExcelValue(item.employee?.designation?.name)}</td>
              <td>${escapeExcelValue(
                item.employee?.designation?.is_officer === 1
                  ? 'Officer'
                  : item.employee?.designation?.type === 1
                    ? 'Staff'
                    : item.employee?.designation?.type === 2
                      ? 'Worker'
                      : item.employee?.designation?.type === 3
                        ? 'Daily Wager'
                        : '',
              )}</td>
              <td>${escapeExcelValue(item.employee?.department?.name)}</td>
              ${attendanceDateCell}
              <td>${escapeExcelValue(item.is_updated ? item.updated_type : item.type || '-')}</td>
              <td colspan="9" style="text-align:center;color:#1565C0;">${escapeExcelValue(
                item.type !== 'Public Holiday' ? item.type : item.remarks,
              )}</td>
            </tr>`
        }

        return `
          <tr>
            <td>${escapeExcelValue(index + 1)}</td>
            <td>${escapeExcelValue(item.employee?.id)}</td>
            <td>${escapeExcelValue(item.employee?.full_name)}</td>
            <td>${escapeExcelValue(item.employee?.designation?.name)}</td>
            <td>${escapeExcelValue(
              item.employee?.designation?.is_officer === 1
                ? 'Officer'
                : item.employee?.designation?.type === 1
                  ? 'Staff'
                  : item.employee?.designation?.type === 2
                    ? 'Worker'
                    : item.employee?.designation?.type === 3
                      ? 'Daily Wager'
                      : '',
            )}</td>
            <td>${escapeExcelValue(item.employee?.department?.name)}</td>
            ${attendanceDateCell}
            <td>${escapeExcelValue(item.is_updated ? item.updated_type : item.type || '-')}</td>
            <td>${escapeExcelValue(item.is_updated ? item.updated_check_in : item.check_in || '-')}</td>
            <td>${escapeExcelValue(item.is_updated ? item.updated_check_out : item.check_out || '-')}</td>
            <td>${escapeExcelValue(
              item.is_updated
                ? wtRoundNumberToSpecifedDigits(item.updated_late_coming) + ' min'
                : item.late_coming
                  ? wtRoundNumberToSpecifedDigits(item.late_coming) + ' min'
                  : '-',
            )}</td>
            <td>${escapeExcelValue(
              item.is_updated
                ? wtRoundNumberToSpecifedDigits(item.updated_early_going) + ' min'
                : item.early_going
                  ? wtRoundNumberToSpecifedDigits(item.early_going) + ' min'
                  : '-',
            )}</td>
            <td>${escapeExcelValue(
              wtConvertHourValue(item.is_updated ? item.updated_working_hours : item.working_hours),
            )}</td>
            <td>${escapeExcelValue(wtConvertHourValue(item.shift_duration))}</td>
            <td>${escapeExcelValue(getDifference(item))}</td>
            <td>${escapeExcelValue(
              item.overtime_hours
                ? wtRoundNumberToSpecifedDigits(item.overtime_hours > 0 ?? 0) + ' Hours'
                : '-',
            )}</td>
            <td>${escapeExcelValue(
              item.is_overtime_approved === 0
                ? '-'
                : item.updated_overtime_hours
                  ? wtRoundNumberToSpecifedDigits(item.updated_overtime_hours > 0 ?? 0) + ' Hours'
                  : '-',
            )}</td>
          </tr>`
      })
      .join('')

    return `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Attendance</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
          <style>
            table{border-collapse:collapse;width:100%;}
            td,th{border:1px solid #cfd8e3;padding:6px 8px;vertical-align:middle;}
            th{background:#1F4E78;color:#fff;font-weight:700;text-align:center;}
          </style>
        </head>
        <body>
          <table>
            <tr>
              <th>Sr</th>
              <th>ID</th>
              <th>Full Name</th>
              <th>Designation</th>
              <th>Type</th>
              <th>Department</th>
              <th>Attendance Date</th>
              <th>Attendance Status</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Late Coming</th>
              <th>Early Going</th>
              <th>Working Hours</th>
              <th>Shift Duration</th>
              <th>Difference</th>
              <th>Overtime Hours</th>
              <th>Approved Overtime</th>
            </tr>
            ${rows}
          </table>
        </body>
      </html>
    `
  }

  const exportToExcel = () => {
    const excelBlob = new Blob([buildExcelHtml()], {
      type: 'application/vnd.ms-excel;charset=utf-8;',
    })
    lzDownloadBlobFile(
      excelBlob,
      `Attendance_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}.xls`,
    )
  }

  useEffect(() => {
    Base.dropdownData(
      'employees,branches,designations,departments',
      {},
      [setEmployees, setBranches, setDesignations, setDepartments],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Employee Attendance Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    <CCol md={3}>
                      <div className="form-group">
                        <label>Date Range: </label>
                        <DatePicker.RangePicker
                          onChange={(value) => changeValues('date_range', value)}
                          style={{ width: '100%', height: 35 }}
                          value={dateRange}
                        />
                      </div>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Employee</label>
                        <WidgetEmployeeSelector
                          employees={Employees}
                          displayValue={EmployeeName}
                          value={EmployeeId}
                          placeholder="Select Employee"
                          onChange={(values) => changeValues('employee_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('employees', {}, [setEmployees], 1)
                          }
                        />
                        {errors.employee_id && <ErrorMessage messages={errors.employee_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() => getDepartments(branchId)}
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>

                    <CCol md={3}>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'nowrap',
                          alignItems: 'flex-end',
                          gap: '6px',
                          marginTop: '20px',
                          marginBottom: '20px',
                        }}
                      >
                        <CButton
                          color="warning"
                          className="text-white"
                          onClick={() => setIsMore(!isMore)}
                        >
                          More
                        </CButton>
                        <CButton
                          color="success"
                          onClick={exportToExcel}
                          className="text-white"
                        >
                          Export
                        </CButton>
                        <CButton
                          color="primary"
                          onClick={() => getReportData()}
                        >
                          Search
                        </CButton>
                        <CButton
                          color="danger"
                          className="text-white"
                          onClick={generatePDF}
                        >
                          PDF
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                  {isMore && (
                    <>
                      <CRow>
                        <CCol md={3}>
                          <CInputGroup
                            style={{ marginTop: '-5px' }}
                          >
                            <label>Designation</label>
                            <WidgetDesignationSelector
                              designations={designations}
                              displayValue={designation_name}
                              value={designation_id}
                              placeholder="Select Designation"
                              onChange={(values) => changeValues('designation_id', values)}
                              reloadDropdownData={() =>
                                Base.dropdownData('departments', {}, [setDepartments], 1)
                              }
                            />
                            {errors.designation_id && (
                              <ErrorMessage messages={errors.designation_id} />
                            )}
                          </CInputGroup>
                        </CCol>

                        <CCol md={3}>
                          <CInputGroup
                            style={{ marginTop: '-5px' }}
                          >
                            <label>Job Type:</label>
                            <WidgetSelector
                              options={JobTypeOptions}
                              placeHolder={'Please Select'}
                              selectedValue={JobType}
                              onChange={(values) => setJobType(values.value)}
                            />
                            {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={3}>
                          <CInputGroup>
                            <label>Resignation Status</label>
                            <WidgetSelector
                              options={RESIGNATION_STATUS_DROPDOWN_OPTIONS}
                              placeHolder={'Please Select'}
                              selectedValue={ResignationStatus}
                              onChange={(values) => changeValues('resignation_status', values)}

                            />
                            {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={3}>
                          <CInputGroup>
                            <label>Parent Branch</label>
                            <WidgetBranchSelector
                              branches={branches}
                              displayValue={branch_name}
                              value={branchId}
                              placeholder="Select Branch"
                              onChange={(values) => changeValues('branch_id', values)}
                              reloadDropdownData={() =>
                                Base.dropdownData('branches', {}, [setBranches], 1)
                              }
                            />
                            {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={3}>
                          <CInputGroup>
                            <label>Attendance Status</label>
                            <Select
                              isMulti
                              isClearable
                              options={EmployeeAttendanceTypeOptions}
                              value={AttendanceStatuses}
                              placeholder="Select Attendance Status"
                              onChange={(values) => changeValues('attendance_status', values)}
                              closeMenuOnSelect={false}
                              styles={{
                                container: (base) => ({ ...base, width: '100%' }),
                                control: (base) => ({ ...base, minHeight: 35 }),
                              }}
                            />
                          </CInputGroup>
                        </CCol>
                      </CRow>
                    </>
                  )}
                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        <table className="table table-bordered data-table">
          {isLoading ? (
            Loading
          ) : (
            <>
              {reportData.length > 0 ? (
                <DataReportTable
                  reportData={reportData}
                  setReportData={(data) => setReportData(data)}
                  isLoading={isLoading}
                  formatDate={formatDate}
                />
              ) : (
                <tbody>
                  <tr
                    style={{
                      border: 0,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '19px',
                    }}
                  >
                    <td>No record to show...</td>
                  </tr>
                </tbody>
              )}
            </>
          )}
        </table>
      </div>
    </>
  )
}
